module.exports = __webpack_public_path__ + "img/greypfeffersal.5aa002cd.webp";